import React from 'react';
export const KpiPendingCreditIcon = () => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none" },
    React.createElement("path", { d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z", stroke: "#0066F4", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
